import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { DashboardView } from "@/components/admin/DashboardView";
import { ProductsView } from "@/components/admin/ProductsView";
import { OrdersView } from "@/components/admin/OrdersView";
import { ClientsView } from "@/components/admin/ClientsView";
import { RevenueView } from "@/components/admin/RevenueView";
import { AdminLoginsView } from "@/components/admin/AdminLoginsView";
import { EmailAccountsView } from "@/components/admin/EmailAccountsView";

const VIEWS = {
  dashboard: DashboardView,
  products: ProductsView,
  orders: OrdersView,
  clients: ClientsView,
  revenue: RevenueView,
  admins: AdminLoginsView,
  emails: EmailAccountsView,
};

export default function Admin() {
  const [params, setParams] = useSearchParams();
  const view = VIEWS[params.get("view")] ? params.get("view") : "dashboard";
  const [stats, setStats] = useState(null);

  const loadStats = useCallback(() => api.get("/admin/stats").then((r) => setStats(r.data)), []);
  useEffect(() => {
    loadStats();
  }, [loadStats, view]);

  const go = (v) => setParams(v === "dashboard" ? {} : { view: v });
  const View = VIEWS[view];

  return (
    <div data-testid="admin-page" className="mx-auto max-w-7xl px-6 py-10">
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-purple-950 mb-2">Admin Dashboard</h1>
      <p className="text-muted-foreground mb-8">Manage your catalogue, orders, clients, admins and email accounts.</p>
      <div className="flex flex-col lg:flex-row gap-8">
        <AdminSidebar active={view} onSelect={go} />
        <main className="flex-1 min-w-0">
          <View stats={stats} onNavigate={go} onBack={() => go("dashboard")} onChanged={loadStats} />
        </main>
      </div>
    </div>
  );
}
